import React from 'react'

interface FrontPageDisclaimerProps {
   getString: (key: string, fallback?: string) => string
   showTaxDisclaimer?: boolean
   showExpiringDiscountDisclaimer?: boolean
}

export default function FrontPageDisclaimer({
   getString,
   showTaxDisclaimer = true,
   showExpiringDiscountDisclaimer = false,
}: FrontPageDisclaimerProps) {
   const monthlyFeesText = getString(
      'pdf.frontpage.disclaimer.monthly_fees',
      '* Monthly fees are based on the number of active employees',
   )
   const taxDisclaimerText = getString(
      'pdf.frontpage.disclaimer.tax',
      '** Plus sales tax if applicable',
   )
   const servicesText = getString(
      'pdf.frontpage.disclaimer.services',
      'See the following pages for line item breakdown of services.',
   )
   const timeLimitedDiscountDisclaimerText = getString(
      'pdf.frontpage.disclaimer.time_limited_discount',
      '',
   )

   return (
      <div className='frontPageDisclaimer'>
         <div className='disclaimerLeft'>
            <div className='disclaimerItem'>
               {monthlyFeesText}
               {showExpiringDiscountDisclaimer &&
                  timeLimitedDiscountDisclaimerText !== '' && (
                     <div style={{ paddingTop: '0.2em' }}>
                        <div style={{ paddingLeft: '1ch' }}>
                           {timeLimitedDiscountDisclaimerText}
                        </div>
                     </div>
                  )}
            </div>
            {showTaxDisclaimer && (
               <div className='disclaimerItem'>{taxDisclaimerText}</div>
            )}
         </div>
         <div className='disclaimerRight'>{servicesText}</div>
      </div>
   )
}
